import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon MyNetworkIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const MyNetworkIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 40 40">
      <g>
        <g display="none">
          <g display="inline">
            <g>
              <g>
                <path
                  fill="none"
                  d="M11,20.76c2.14,0,3.88-1.74,3.88-3.88S13.14,13,11,13s-3.88,1.74-3.88,3.88 C7.12,19.03,8.86,20.76,11,20.76z"
                />
              </g>
              <g>
                <path
                  fill="none"
                  d="M9.24,20.06h3.53c2.33,0,4.24,1.91,4.24,4.24v2.82H5V24.3C5,21.96,6.91,20.06,9.24,20.06z"
                />
              </g>
              <g>
                <path
                  fill="none"
                  d="M29,20.76c2.14,0,3.88-1.74,3.88-3.88S31.14,13,29,13s-3.88,1.74-3.88,3.88 C25.12,19.03,26.86,20.76,29,20.76z"
                />
              </g>
              <g>
                <path
                  fill="none"
                  d="M27.24,20.06h3.53c2.33,0,4.24,1.91,4.24,4.24v2.82H23V24.3C23,21.96,24.91,20.06,27.24,20.06z"
                />
              </g>
              <g>
                <path
                  fill="none"
                  d="M20,21.35c2.86,0,5.18-2.32,5.18-5.18S22.86,11,20,11s-5.18,2.32-5.18,5.18S17.14,21.35,20,21.35z"
                />
              </g>
              <g>
                <path
                  fill="none"
                  d="M17.65,20.41h4.71c3.11,0,5.65,2.54,5.65,5.65v3.76H12v-3.76C12,22.95,14.54,20.41,17.65,20.41z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <g>
        <path
          fill="none"
          d="M23.03,20.47c0.5,0.06,0.99,0.19,1.44,0.37c0.52-0.41,1.13-0.72,1.81-0.86c-0.64-0.56-1.1-1.3-1.3-2.15 C24.62,18.9,23.94,19.82,23.03,20.47z"
        />
        <path
          fill="none"
          d="M13.71,19.98c0.66,0.15,1.26,0.45,1.77,0.85c0.46-0.19,0.96-0.31,1.48-0.37c-0.91-0.64-1.58-1.57-1.94-2.64 C14.82,18.68,14.35,19.42,13.71,19.98z"
        />
        <path
          fill="none"
          d="M11,19.52c1.46,0,2.64-1.18,2.64-2.64s-1.19-2.64-2.64-2.64s-2.64,1.18-2.64,2.64S9.54,19.52,11,19.52z"
        />
        <path
          fill="none"
          d="M14.05,21.68c-0.39-0.19-0.82-0.31-1.29-0.31H9.24c-1.64,0-2.92,1.28-2.92,2.92L6.31,25.8h5.7 C12.09,24.12,12.85,22.66,14.05,21.68z"
        />
        <circle fill="none" cx={29} cy={16.88} r={2.64} />
        <path
          fill="none"
          d="M30.76,21.37h-3.53c-0.48,0-0.93,0.12-1.32,0.32c1.21,0.98,1.99,2.46,2.07,4.11h5.7v-1.51 C33.68,22.68,32.37,21.37,30.76,21.37z"
        />
        <path d="M35.18,24.29c0-2.11-1.49-3.87-3.47-4.31c0.87-0.76,1.43-1.86,1.43-3.1c0-2.28-1.86-4.14-4.14-4.14 c-1.72,0-3.19,1.05-3.82,2.55C24.76,12.8,22.6,10.9,20,10.9c-2.61,0-4.76,1.9-5.18,4.39c-0.63-1.49-2.1-2.55-3.82-2.55 c-2.28,0-4.14,1.86-4.14,4.14c0,1.23,0.56,2.33,1.42,3.09c-2.01,0.42-3.47,2.17-3.47,4.32v3.01H12v2.52h15.99V27.3h7.2L35.18,24.29 z M33.68,25.8h-5.7c-0.08-1.66-0.86-3.13-2.07-4.11c0.4-0.2,0.84-0.32,1.32-0.32h3.53c1.61,0,2.92,1.31,2.92,2.92V25.8z M26.5,27.3 v1.02H13.51V27.3v-0.75v-0.49c0-0.09,0.02-0.17,0.03-0.26c0.08-1.28,0.71-2.39,1.67-3.09c0.2-0.15,0.42-0.27,0.65-0.38 c0.22-0.11,0.46-0.19,0.71-0.25c0.35-0.09,0.71-0.16,1.09-0.16h4.71c0.36,0,0.71,0.06,1.05,0.15c0.25,0.07,0.49,0.15,0.72,0.26 c0.22,0.11,0.44,0.23,0.64,0.37c0.98,0.7,1.62,1.82,1.7,3.09c0.01,0.09,0.03,0.17,0.03,0.26v0.49V27.3z M6.32,24.29 c0-1.64,1.28-2.92,2.92-2.92h3.52c0.46,0,0.9,0.12,1.29,0.31c-1.19,0.97-1.96,2.44-2.03,4.12h-5.7L6.32,24.29z M11,14.24 c1.45,0,2.64,1.18,2.64,2.64s-1.18,2.64-2.64,2.64s-2.64-1.18-2.64-2.64S9.55,14.24,11,14.24z M20,12.41 c2.08,0,3.77,1.69,3.77,3.77s-1.69,3.77-3.77,3.77s-3.77-1.69-3.77-3.77S17.92,12.41,20,12.41z M29,14.24 c1.46,0,2.64,1.18,2.64,2.64s-1.18,2.64-2.64,2.64s-2.64-1.18-2.64-2.64S27.54,14.24,29,14.24z M24.47,20.84 c-0.45-0.18-0.94-0.31-1.44-0.37c0.91-0.64,1.59-1.57,1.95-2.64c0.2,0.85,0.67,1.59,1.3,2.15C25.6,20.12,24.99,20.42,24.47,20.84z  M16.96,20.46c-0.52,0.06-1.02,0.19-1.48,0.37c-0.51-0.41-1.11-0.71-1.77-0.85c0.64-0.56,1.11-1.3,1.31-2.16 C15.38,18.9,16.06,19.82,16.96,20.46z" />
        <circle fill="none" cx={20} cy={16.18} r={3.77} />
        <path
          fill="none"
          d="M26.47,25.8c-0.08-1.28-0.73-2.39-1.7-3.09c-0.2-0.14-0.41-0.27-0.64-0.37c-0.23-0.11-0.47-0.19-0.72-0.26 c-0.34-0.09-0.69-0.15-1.05-0.15h-4.71c-0.38,0-0.74,0.06-1.09,0.16c-0.25,0.07-0.48,0.15-0.71,0.25 c-0.23,0.11-0.45,0.23-0.65,0.38c-0.97,0.7-1.6,1.81-1.67,3.09c-0.01,0.09-0.03,0.17-0.03,0.26v0.49v0.75v1.02H26.5V27.3v-0.75 v-0.49C26.5,25.97,26.48,25.89,26.47,25.8z"
        />
      </g>
      <rect fill="none" width={40} height={40} />
      <g>
        <path d="M20,39.99C8.98,39.99,0.01,31.02,0.01,20S8.98,0.01,20,0.01S39.99,8.98,39.99,20S31.02,39.99,20,39.99z  M20,1.51C9.81,1.51,1.51,9.81,1.51,20S9.81,38.49,20,38.49S38.49,30.19,38.49,20S30.19,1.51,20,1.51z" />
      </g>
    </Icon>
  )
}
export default MyNetworkIcon
